import React, { useState } from "react";
import ArticleManagement from "../Articles/ArticleManagement";
import "./MasterDataArticles.css";

const MasterDataArticles = ({
  selectedProject,
  onProjectRefresh,
}) => {
  return (
    <div className="data-config-container">
      <h2>Parts Library</h2>

      <ArticleManagement
        projectId={selectedProject?.id}
        onProjectRefresh={onProjectRefresh}
      />
    </div>
  );
};

export default MasterDataArticles;